import fetch from "node-fetch";
import { URLSearchParams } from "url";

export class Fetch {
  private baseUrl: string;
  private headers: { [key: string]: string } = {
    Accept: "application/json",
  };

  public constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  public setHeader(key: string, value: string) {
    this.headers = { ...this.headers, [key]: value };
  }

  public removeHeader(key: string) {
    delete this.headers[key];
  }

  public async post<T = any, S = { [key: string]: any }>(
    path: string,
    data?: S,
    encode = false,
    headers: { [key: string]: string } = {}
  ): Promise<T> {
    let newHeaders = { ...this.headers, ...headers };

    let body: URLSearchParams | string | null = null;
    if (encode) {
      const params = new URLSearchParams();
      Object.keys(data || {}).forEach((key) =>
        params.append(key, (data as any)[key])
      );
      body = params;
    } else {
      newHeaders = { ...newHeaders, "Content-Type": "application/json" };

      body = JSON.stringify(data);
    }

    try {
      const response = await fetch(`${this.baseUrl}/${path}`, {
        method: "post",
        body,
        headers: newHeaders,
      });

      if (response.status > 300) {
        const payload = await response.json();

        if (response.status === 404) {
          throw new Error(payload?.message || "Não conectado");
        }

        if (response.status === 401) {
          throw new Error(payload?.message || "Não autorizado");
        }

        throw new Error(payload?.message || "Um erro interno aconteceu");
      }

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  public async put<T = any, S = { [key: string]: any }>(
    path: string,
    data: S,
    encode = false,
    headers: { [key: string]: string } = {}
  ): Promise<T> {
    let newHeaders = { ...this.headers, ...headers };

    let body: URLSearchParams | string | null = null;
    if (encode) {
      const params = new URLSearchParams();
      Object.keys(data).forEach((key) =>
        params.append(key, (data as any)[key])
      );
      body = params;
    } else {
      newHeaders = { ...newHeaders, "Content-Type": "application/json" };

      body = JSON.stringify(data);
    }

    try {
      const response = await fetch(`${this.baseUrl}/${path}`, {
        method: "put",
        body,
        headers: newHeaders,
      });

      if (response.status > 300) {
        const payload = await response.json();

        if (response.status === 404) {
          throw new Error(payload?.message || "Não conectado");
        }

        if (response.status === 401) {
          throw new Error(payload?.message || "Não autorizado");
        }

        throw new Error(payload?.message || "Um erro interno aconteceu");
      }

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  public async get<T = any>(
    path: string,
    headers: { [key: string]: string } = {}
  ) {
    const newHeaders = {
      ...this.headers,
      ...headers,
    };

    const response = await fetch(`${this.baseUrl}/${path}`, {
      method: "get",
      headers: newHeaders,
    });

    if (response.status > 300) {
      const payload = await response.json();
      throw new Error(payload?.message || "Um erro interno aconteceu");
    }

    try {
      const json = await response.json();
      return json as T;
    } catch (err) {
      return null;
    }
  }

  public async del<T = any>(
    path: string,
    headers: { [key: string]: string } = {}
  ) {
    const newHeaders = { ...this.headers, ...headers };

    const response = await fetch(`${this.baseUrl}/${path}`, {
      method: "delete",
      headers: newHeaders,
    });

    if (response.status > 300) {
      const payload = await response.json();
      throw new Error(payload?.message || "Um erro interno aconteceu");
    }

    return (await response.json()) as T;
  }
}
